/**
 * 将当前页面的页面名称、模块名称、位置信息记录下来，传递到下一个页面去
 * @Author: moonye
 * @Date: 2018-06-26 17:08:48
 * @Last Modified by: moonye
 * @Last Modified time: 2020-03-09 21:45:53
 */
import cookie from '@tencent/im-cookie';
import { query } from './util.bom';
import winname from './util.winname';
import util from './util';
import urlpageHandler from './lastUrlpageHandler';

const referer = document.referrer;
const referObj = util.parseHref(referer);

const cookieConfig = {
  name: 'report_position_key',
  domain: 'ke.qq.com',
  path: '/'
};

const courseReg = /\/course\/\d+$/i;
const coursePkgReg = /\/course\/package\/\d+$/i;



function getPositionData() {
  // 在 iframe 不处理 url_page 逻辑
  if (util.isInIframe()) {
    return;
  }

  const preUrlPage = urlpageHandler.get();
  if (preUrlPage) {
    return preUrlPage;
  }

  // 支持 3 中取数据方式，从链接、winname、cooke中获取（winname会慢慢丢弃）
  const retData = getQueryData() || getWinnameData() || getCookieData() || getReferData();

  // 数据缓存下来，留作刷新的时候用
  urlpageHandler.set(retData);

  // 返回数据之前，decode 下
  if (retData && retData.url_module) {
    retData.url_module = decodeURIComponent(retData.url_module);
  }
  return retData;
}

function getCookieData() {
  let v;
  try {
    v = cookie.get(cookieConfig.name);
    if (v) {
      v = JSON.parse(v);
    }
  } catch (e) {
    v = {};
    console.log(e);
  }
  cookie.del(cookieConfig.name, cookieConfig.domain, cookieConfig.path);
  return v || {};
}

function getQueryData() {
  var page = query('page') || query('url_page');
  var modulename = query('module') || query('url_module');
  var position = query('position') || query('url_position');
  if (page) {
    return {
      url_page: page,
      url_module: modulename,
      url_position: position,
    };
  }
  return null;
}
function getWinnameData() {
  let v;
  try {
    v = winname.get(cookieConfig.name);
    if (v) {
      v = JSON.parse(v);
    }
  } catch (e) {
    v = {};
  }
  winname.del(cookieConfig.name);
  return v;
}

/**
 * @deprecated
 */
function getReferData() {
  const pathname = referObj.pathname;
  if (courseReg.test(pathname) || pathname === '/m-core/course.html') {
    return { url_page: 'course' };
  }
  if (coursePkgReg.test(pathname)) {
    return { url_page: 'coursegroup' };
  }
  return;
}

function setCookieData(d) {
  // 在 iframe 不处理 url_page 逻辑
  if (util.isInIframe()) {
    return;
  }

  cookie.setSession(cookieConfig.name, JSON.stringify(d), cookieConfig.domain, cookieConfig.path);
}


/**
 * 和 position data 相关的操作 api
 * @param {*} dataFromCookie
 * @param {*} report
 */
export default {
  getPositionData: getPositionData,
  setPositionData: setCookieData,
};
